export default __webpack_public_path__ + "static/media/line-arrow-left.62cac523.svg";